export type ReceiptPaperWidth = '58mm' | '80mm';

export interface ReceiptPrinter {
  print(width: ReceiptPaperWidth): void;
}

export class BrowserPrintReceiptPrinter implements ReceiptPrinter {
  print(width: ReceiptPaperWidth): void {
    document.documentElement.dataset['receiptWidth'] = width;
    window.print();
  }
}
